var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.appComponent,{tag:"component",on:{"wheel":function($event){return _vm.console.log($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }